/**
 * Check whether an email is valid or not.
 *
 * @param {string} email
 *
 * @returns {boolean}
 */
const isEmailAddressValid = (email) => {
    const regex = new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)' +
        '|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');
    return regex.test(email);
};
export default isEmailAddressValid;
